import clsx from "clsx"
import gsap from "gsap"
import { type ReactElement, memo } from "react"
import { Card } from "@/ui/Card"
import { type IOpponentCardList } from "./types"

export const OpponentCardList = memo(function OpponentCardList({
  items,
  isMatchActive
}: IOpponentCardList): ReactElement[] {
  return items.map((el, i) => {
    const progress = ((i + 1) * 100) / (items.length - 1 + 2) / 100

    const translateX = gsap.utils.interpolate(0, 300, progress) - 150
    const translateY = gsap.utils.interpolate([-60, -30, -60], progress)
    const rotate = gsap.utils.interpolate([30, 0, -30], progress)
    const zIndex = Math.round(gsap.utils.interpolate([1, 10, 1], progress))
    const transform = `translateX(-50%) translateX(${translateX}%) translateY(${translateY}%) rotate(${rotate}deg)`

    return (
      <Card
        {...el}
        className={clsx("box", el.status)}
        dataFlipId={`card-${el.id}`}
        style={{
          transform,
          zIndex
        }}
        isMatchActive={isMatchActive}
        key={`card-${el.id}`}
      >
        {el.id}
      </Card>
    )
  })
})
